import React from 'react';

const Headings = ({ title, text }) => {
    return (
        <div className="m-1">
            <h2 className="font-serif font-bold text-3xl text-brand-900">{title}</h2>
            <p className="font-bold text-ink/70">{text}</p>
        </div>
    )
}

export default Headings
